import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ApiKeysTab = ({ token }) => {
  const [keys, setKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showKey, setShowKey] = useState(null);
  const [branches, setBranches] = useState([]);
  const [form, setForm] = useState({ name: '', branch_id: '', rate_limit_per_min: 60, expires_in_days: 30, permissions: { all: true } });
  const [editing, setEditing] = useState(null);

  const headers = { Authorization: `Bearer ${token}` };

  const fetchKeys = async () => {
    try {
      const [kRes, bRes] = await Promise.all([
        axios.get('/api/admin/api-keys', { headers }),
        axios.get('/api/branches/all', { headers })
      ]);
      setKeys(kRes.data.data || []);
      setBranches(bRes.data || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchKeys(); }, [token]);

  const createKey = async () => {
    try {
      const res = await axios.post('/api/admin/api-keys', {
        ...form,
        branch_id: form.branch_id || null,
        permissions: form.permissions
      }, { headers });
      setShowKey(res.data.data);
      setShowModal(false);
      setForm({ name: '', branch_id: '', rate_limit_per_min: 60, expires_in_days: 30, permissions: { all: true } });
      fetchKeys();
    } catch (e) {
      alert('Hata: ' + (e.response?.data?.error?.message || e.message));
    }
  };

  const toggleKey = async (id, currentActive) => {
    try {
      await axios.put(`/api/admin/api-keys/${id}`, { is_active: !currentActive }, { headers });
      fetchKeys();
    } catch (e) { console.error(e); }
  };

  const deleteKey = async (id) => {
    if (!window.confirm('Bu API anahtarını silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`/api/admin/api-keys/${id}`, { headers });
      fetchKeys();
    } catch (e) { console.error(e); }
  };

  if (loading) return <div className="empty">Yükleniyor...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3 style={{ margin: 0, color: '#FFFFFF', fontSize: '18px' }}>🔑 API Anahtarları</h3>
        <button className="btn-approve" onClick={() => setShowModal(true)}>+ Yeni Anahtar</button>
      </div>

      {keys.length === 0 ? (
        <div className="empty">Henüz API anahtarı oluşturulmamış</div>
      ) : keys.map(k => (
        <div key={k.id} className="item-card" style={{ marginBottom: '8px' }}>
          <div>
            <div className="item-header">
              <strong>{k.name}</strong>
              <span className={`badge ${k.is_active ? 'active' : 'inactive'}`}>{k.is_active ? 'Aktif' : 'Pasif'}</span>
              {k.branch_name && <span className="badge">{k.branch_name}</span>}
            </div>
            <div className="item-details">
              <span>Prefix: <code style={{ color: '#60A5FA' }}>{k.key_prefix}***</code></span>
              <span>Limit: {k.rate_limit_per_min} / dk</span>
              <span>Son: {k.last_used_at ? new Date(k.last_used_at).toLocaleDateString('tr-TR') : '-'}</span>
              {k.expires_at && <span>Bitiş: {new Date(k.expires_at).toLocaleDateString('tr-TR')}</span>}
            </div>
          </div>
          <div className="item-actions">
            <button className={`btn-toggle`} onClick={() => toggleKey(k.id, k.is_active)}>
              {k.is_active ? 'Pasif Yap' : 'Aktif Yap'}
            </button>
            <button className="btn-delete" onClick={() => deleteKey(k.id)}>Sil</button>
          </div>
        </div>
      ))}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ width: '480px' }}>
            <h3>🔑 Yeni API Anahtarı</h3>
            <div className="form-group">
              <label>Anahtar Adı</label>
              <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Mobil Uygulama" />
            </div>
            <div className="form-group">
              <label>Şube</label>
              <select value={form.branch_id} onChange={e => setForm({ ...form, branch_id: e.target.value })}>
                <option value="">Tüm Şubeler</option>
                {branches.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Rate Limit (istek/dk)</label>
              <input type="number" value={form.rate_limit_per_min} onChange={e => setForm({ ...form, rate_limit_per_min: parseInt(e.target.value) })} />
            </div>
            <div className="form-group">
              <label>Geçerlilik Süresi</label>
              <select value={form.expires_in_days} onChange={e => setForm({ ...form, expires_in_days: parseInt(e.target.value) })}>
                <option value={0}>Süresiz</option>
                <option value={7}>7 Gün</option>
                <option value={30}>30 Gün</option>
                <option value={90}>90 Gün</option>
                <option value={365}>1 Yıl</option>
              </select>
            </div>
            <div className="modal-actions" style={{ marginTop: '20px' }}>
              <button className="btn-cancel" onClick={() => setShowModal(false)}>İptal</button>
              <button className="btn-approve" onClick={createKey} disabled={!form.name}>Oluştur</button>
            </div>
          </div>
        </div>
      )}

      {showKey && (
        <div className="modal-overlay" onClick={() => setShowKey(null)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ width: '520px' }}>
            <h3>✅ API Anahtarı Oluşturuldu</h3>
            <div className="info-box" style={{ margin: '16px 0', wordBreak: 'break-all', textAlign: 'center', padding: '20px' }}>
              <code style={{ fontSize: '18px', color: '#34D399' }}>{showKey.key}</code>
            </div>
            <p style={{ color: '#FCA5A5', fontSize: '13px', textAlign: 'center' }}>
              ⚠️ Bu anahtar bir daha gösterilmez! Güvenli bir yere kaydedin.
            </p>
            <div className="modal-actions">
              <button className="btn-approve" onClick={() => { navigator.clipboard?.writeText(showKey.key); alert('Kopyalandı!'); }}>📋 Kopyala</button>
              <button className="btn-cancel" onClick={() => setShowKey(null)}>Tamam</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApiKeysTab;
